import { render, staticRenderFns } from "./OverviewHeader.vue?vue&type=template&id=3fa8400d&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=js"
export * from "./OverviewHeader.vue?vue&type=script&lang=js"
import style0 from "./OverviewHeader.vue?vue&type=style&index=0&id=3fa8400d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8400d",
  null
  
)

export default component.exports